module.exports = __webpack_public_path__ + "img/shipo-undraw-404.c2f5c831.svg";